import apiFetch from '../apiFetch'

export default function (token, dossierSubTypeId) {
  return apiFetch({ endPoint: `purchaseType/dossierSubType/${dossierSubTypeId}`, method: 'GET', body: null, token: token })
}
